exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.flex-center[data-v-2e72e89f] {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n", ""]);
